export default __webpack_public_path__ + "static/media/dds5168_4p-2.a18073fd.png";